/**
 * Resolves the iframe URL for Zolaid Computer’s optional VS Code tab (e.g. code-server).
 *
 * Priority: explicit value from parent → REACT_APP_VSCODE_EMBED_URL (build-time) →
 * in development only, http://127.0.0.1:8080 so the tab appears without env churn.
 *
 * Production builds omit the dev fallback; set REACT_APP_VSCODE_EMBED_URL for deploys.
 */
export function resolveVscodeEmbedUrl(explicit) {
  if (explicit != null && String(explicit).trim() !== '') {
    return String(explicit).trim();
  }
  const fromEnv = (process.env.REACT_APP_VSCODE_EMBED_URL || '').trim();
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:8080';
  }
  return null;
}

/** Default Computer tab: VS Code iframe when embed URL exists, else Monaco workspace. */
export function defaultZolaidComputerViewMode() {
  return resolveVscodeEmbedUrl(null) ? 'vscode' : 'code';
}
